import React, { useContext } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import { motion } from "framer-motion";

import HTML from '../global/HTML'
import Circle from '../global/Circle'
import Container from '../global/Container'

import DisplayContext from '../../contexts/DisplayContext'

const ValuePropComponent = ({ content, shadowColor, size, className }) => {

  const display = useContext(DisplayContext);

  const frontCircle = {
    hidden: {
      opacity: 0
    },
    punched: { 
      y: -40,
      opacity: 1,
      transition: { delay: 2 },
    },
  }

  const backCircle = {
    hidden: {
      opacity: 0
    },
    punched: { 
      y: 20,
      opacity: 1,
      transition: { delay: 2 },
    },
  }

  return (
    <div className={className}>
      <Container>
        <div className="container">
        <motion.div
            animate="punched"
            variants={frontCircle}
            className="front-circle" 
            initial={display == 'live' ? 'hidden' : 'punched'}
          >
          <Circle background="#000" color="#fff" opacity="1" size={size} floating={false}>
            <HTML content={content} />
          </Circle>
        </motion.div>
        <motion.div
            animate="punched"
            variants={backCircle}
            className="back-circle" 
            initial={display == 'live' ? 'hidden' : 'punched'}
          >
          <Circle background={shadowColor} opacity="1" size={size} floating={false} />
        </motion.div>
        </div>
      </Container>
    </div>
  )
}
ValuePropComponent.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  shadowColor: PropTypes.string,
  size: PropTypes.string,
}
ValuePropComponent.defaultProps = {
  shadowColor: '#FF81F2',
  size: '214',
};
  
const ValueProp = styled(ValuePropComponent)`
  ${tw``}
  position: absolute;
  z-index: 4;
  bottom: 80px;
  width: 100%;
  svg {
    height: 214px;
  }
  @media (max-width: 767px) {
    .content {
      font-size: 1rem;
    }
  }
  @media (max-width: 639px) {
    bottom: auto;
    top: 300px;
    transform: scale(0.7);
    .content {
      font-size: 1rem;
    }
    transform-origin: left;
  }
  .container {
    position: relative;
    height: 300px;
  }
  .front-circle {
    position: relative;
    z-index: 2;
  }
  .back-circle {
    position: absolute;
    left: 0;
    z-index: 1;
    top: 0;
  }
`

export default ValueProp